import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import EngagementMolesInfo from '../components/EngagementMolesInfo';
import { ServicesSection } from '../components/ServicesSection';

import imgI from '@/assets/pexels-iriser-1379636.jpg';
import serviceImg from '@/assets/service_illustration.svg';
import { logContactClick } from '@/utils/analytics-utils';
import { scrollToElement } from '@/utils/scroll-to-element';

export const Services = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('services');

  return (
    <>
      <div className="section">
        <h1 className="section-title flex justify-self-center">{t('title')}</h1>

        <div className="flex justify-center mt-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:w-4/6">
            <div className="col-span-2">
              <div className="section-content">{t('subtitle')}</div>

              <div className="flex justify-center md:justify-start items-center mt-8">
                <button
                  className="action-button"
                  onClick={() => {
                    logContactClick('Services_IntroSection', t('getOffer'));
                    scrollToElement('contact-section');
                  }}
                >
                  {t('getOffer')}
                </button>
              </div>
            </div>
            <div className="flex justify-center items-center">
              <img
                src={serviceImg}
                alt={t('title')}
                className="h-[50v] object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
      <ServicesSection />
      <EngagementMolesInfo />
    </>
  );
};
